import { ComponentProps, forwardRef } from "react";
import { TextField } from "../TextField";

type SelectProps = Omit<ComponentProps<typeof TextField<"select">>, "as">;
export const Select = forwardRef<HTMLSelectElement, SelectProps>((props, ref) => {
  return <TextField {...props} as={"select"} ref={ref} />;
});

Select.displayName = "Select";
